import { Instagram, Linkedin, Mail, Phone } from "lucide-react";
import logo from "@/assets/videoagentur-aachen-logo.png";
import { showCookieBanner } from "./CookieConsent";

const Footer = () => {
  return (
    <footer className="py-12 md:py-16 border-t border-border bg-background/50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8">
          {/* Logo & Tagline */}
          <div className="flex flex-col items-center md:items-start space-y-4">
            <img 
              src={logo} 
              alt="Videoagentur Aachen - JC Productions Logo" 
              className="h-5 w-auto opacity-90"
              width="88"
              height="20"
              loading="lazy"
              decoding="async"
            />
            <p className="text-sm text-muted-foreground text-center md:text-left max-w-xs">
              Real Filmmaking Meets AI – Hochwertige Markenfilme und Reels mit oder ohne Drehtag
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center space-y-3">
            <h3 className="text-sm font-bold text-foreground mb-1 tracking-tight">Links</h3>
            <div className="flex flex-col items-center gap-2 text-sm">
              <a 
                href="/impressum" 
                className="text-muted-foreground hover:text-[hsl(var(--electric-green))] transition-colors"
              >
                Impressum
              </a>
              <a 
                href="/datenschutz" 
                className="text-muted-foreground hover:text-[hsl(var(--electric-green))] transition-colors"
              >
                Datenschutz
              </a>
              <a 
                href="/agb" 
                className="text-muted-foreground hover:text-[hsl(var(--electric-green))] transition-colors"
              >
                AGB
              </a>
              <button
                onClick={showCookieBanner}
                className="text-muted-foreground hover:text-[hsl(var(--electric-green))] transition-colors"
              >
                Cookie-Einstellungen
              </button>
              <a 
                href="#contact" 
                className="text-muted-foreground hover:text-[hsl(var(--electric-green))] transition-colors"
              >
                Kontakt
              </a>
            </div>
          </div>

          {/* Contact & Social */}
          <div className="flex flex-col items-center md:items-end space-y-4">
            <h3 className="text-sm font-bold text-foreground tracking-tight">Kontakt</h3>
            <div className="flex flex-col items-center md:items-end gap-2 text-sm text-muted-foreground">
              <a 
                href="mailto:hello@aivinity.de"
                className="flex items-center gap-2 hover:text-[hsl(var(--electric-green))] transition-colors"
              >
                <Mail className="w-4 h-4" />
                hello@aivinity.de
              </a>
              <a 
                href="tel:+4915772982459"
                className="flex items-center gap-2 hover:text-[hsl(var(--electric-green))] transition-colors"
              >
                <Phone className="w-4 h-4" />
                +49 1577 2982459
              </a>
            </div>
            
            <div className="flex gap-4 mt-2">
              <a
                href="https://instagram.com/jcproductions.de"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Folge uns auf Instagram"
                className="text-muted-foreground hover:text-[hsl(var(--electric-green))] transition-colors hover-scale"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/in/janclassen/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Verbinde dich auf LinkedIn"
                className="text-muted-foreground hover:text-[hsl(var(--electric-green))] transition-colors hover-scale"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-border text-center space-y-2">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Aivinity – Alle Rechte vorbehalten
          </p>
          {/* TEMP: Onboarding Link - Remove later */}
          <a 
            href="/onboarding" 
            className="inline-block text-[10px] text-muted-foreground/60 hover:text-accent transition-colors"
          >
            Client Onboarding
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
